module.exports = __webpack_public_path__ + "img/icon-popup-success.4e9e942b.png";